import React, { useEffect } from 'react';
import { useAds } from 'hooks/use-ads';
import { AdSlotMarker, AdSlotMarkerProps } from '../ad-slot-marker/ad-slot-marker';

import './ad-slot.scss';

const AdSlot: React.FC<AdSlotMarkerProps> = ({
    id,
    name,
    lazy,
    resizable,
    className = '',
    children
}) => {
    const ads = useAds();
    const disabledSlots = ads?.disabledSlots ?? [];
    const disabled = !ads?.enabled || disabledSlots.includes(name);

    useEffect((): void => {
        if (disabled === false) {
            window?.dlApi?.cmd?.push((dlApi): void => {
                const slot = dlApi.defineSlot(name, id || `ad-${name}`, {});

                if (children === null) {
                    slot.setCollapseEmpty(true);
                }
            });
        }
    }, []);

    if (disabled) {
        return <>{children}</>;
    }

    return <AdSlotMarker id={id || `ad-${name}`} name={name} auto={false}
        lazy={lazy} resizable={resizable} className={className}
    >
        {children}
    </AdSlotMarker>;
};

export default AdSlot;
